module.exports = __webpack_public_path__ + "static/img/1.aa61edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/1.png
// module id = 0u6j
// module chunks = 9